import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { HintTypeEnum } from '../../../hrm/models/hints-list.model';
import { purchasePriceHints } from '../../price-hints.config';
import {
  BaseMegaHintComponentDependences,
  BaseMegaHintsComponent
} from 'common/src/modules/rnpl-common/components/base-mega-hints/base-mega-hints.component';
import { ProductTypes } from 'common/src/modules/products/product-types';

@Component({
  selector: 'rnpl-purchase-price-mega-hint',
  templateUrl: './purchase-price-mega-hint.component.html',
  styleUrls: ['./purchase-price-mega-hint.component.scss']
})
export class PurchasePriceMegaHintComponent extends BaseMegaHintsComponent implements OnInit, OnChanges {
  @Input() public screenName: string;
  @Input() public activeTab: ProductTypes | string;
  @Input() public hasPrices: boolean;

  constructor(
    public deps: BaseMegaHintComponentDependences
  ) {
    super(deps);
  }

  ngOnInit() {
    this.endFinishText = 'PRICE.PURCHASE_PRICES';
    this.megaHintTimer = 1200;
    this.displayHints();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes.hasOwnProperty('activeTab') ||
      changes.hasOwnProperty('isReadOnly')
    ) {
      clearInterval(this.countdownTimer);
      if (this.shepherdService.isActive) {
        this.shepherdService.cancel();
      }

      if (!!this.screenName) {
        this.initHints();
      }
    }
  }

  private initHints(): void {
    this.hintsList = [];
    this.notViewedHintsList = [];

    this.hrmService.getHintsByPage(this.screenName)
      .pipe(takeUntil(this._destroy))
      .subscribe(hints => {

        if (!!hints.data.hints && !!hints.data.hints.length) {
          this.hintListByName = purchasePriceHints(
            this.activeTab,
            this.hasPrices
          );

          this.hintsList = this.prepareHintsList(hints.data.hints)
            .filter(hint => hint.type !== HintTypeEnum.MEGA)
            .filter(hint => this.hintListByName[hint.name]);

          this.notViewedHintsList = this.prepareHintsList(hints.data.hints)
            .filter(hint => hint.type !== HintTypeEnum.MEGA)
            .filter(hint => !hint.viewed)
            .filter(hint => this.hintListByName[hint.name]);

          this.megaHintId = +hints.data.hints[0].id;

          if (!!this.notViewedHintsList && !!this.notViewedHintsList.length) {
            this.addHintsSteps(this.notViewedHintsList);
          }

          if (!!hints.data.hints && !!hints.data.hints.length && !hints.data.hints[0].viewed && hints.data.hints[0].type === HintTypeEnum.MEGA) {
            this.isCloseHint$.next(false);
            this.startTimerMegaHint();
          } else {
            if (!!this.notViewedHintsList && !!this.notViewedHintsList.length) {
              this.shepherdService.start();
            }
          }
        }
      })
  }
}
